import React from 'react';
import { Chip } from '@mui/material';
import {
  HourglassEmpty,
  Visibility,
  Loop,
  CheckCircle,
  Error,
  EventBusy,
} from '@mui/icons-material';
import { PaymentStatus } from '../../types/PaymentLink';
import { colors } from '../../theme/golfTheme';

interface StatusChipProps {
  status: PaymentStatus;
  size?: 'small' | 'medium';
}

const StatusChip: React.FC<StatusChipProps> = ({ status, size = 'medium' }) => {
  const getStatusConfig = (status: PaymentStatus) => {
    switch (status) {
      case 'pending':
        return {
          label: 'Pending',
          color: colors.status.pending,
          icon: <HourglassEmpty />,
        };
      case 'visited':
        return {
          label: 'Visited',
          color: colors.status.visited,
          icon: <Visibility />,
        };
      case 'processing':
        return {
          label: 'Processing',
          color: colors.status.processing,
          icon: <Loop />,
        };
      case 'partial':
        return {
          label: 'Partial Payment',
          color: colors.status.processing, // Use processing color (orange/yellow)
          icon: <Loop />,
        };
      case 'success':
        return {
          label: 'Success',
          color: colors.status.success,
          icon: <CheckCircle />,
        };
      case 'failed':
        return {
          label: 'Failed',
          color: colors.status.failed,
          icon: <Error />,
        };
      case 'expired':
        return {
          label: 'Expired',
          color: colors.status.expired,
          icon: <EventBusy />,
        };
      case 'overdue':
        return {
          label: 'Overdue',
          color: colors.status.failed, // Use red/error color
          icon: <EventBusy />,
        };
      default:
        console.error('StatusChip - Unknown status:', status);
        return {
          label: 'Unknown',
          color: colors.status.pending,
          icon: <HourglassEmpty />,
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <Chip
      label={config.label}
      icon={config.icon}
      size={size}
      sx={{
        backgroundColor: config.color,
        color: '#ffffff',
        fontWeight: 600,
        '& .MuiChip-icon': {
          color: '#ffffff',
        },
      }}
    />
  );
};

export default StatusChip;
